  /* 国际化zh_tw */

module.exports = {
    base:{
        "nomore" : "Keine weiteren Waren", //沒有更多了
        "sure" : "Bestätigen", //确定
        "not_desc" : "Noch keine Beschreibung", //暂无描述
    },
    common:{
        "get_code" : "Bestätigungscode abrufen", //获取验证码
        "onsale_status" : "Dieses Produkt wurde vom Markt genommen", //
        "s_regain" : "s In Sekunden erneut abrufen", //
        "regain" : "Erneut abrufen", //重新获取
        "cancel" : "Abbrechen", //取消
        "select" : "Auswählen", //选取
        "empty_item" : "Derzeit kein Inhalt", //暂无内容
        "load_fail" : "Laden fehlgeschlagen", //加载失败
        "tabbar_my_name" : "Mein", //
    },
    tabbar:{
        "home" : "Startseite", //首页
        "category" : "Einstufung", //分类
        "cart" : "Warenkorb", //购物车
        "profile" : "Mein", //我的
        "service" : "skype", //客服
    },
    address:{
        "name" : "Name des Empfängers", //
        "name_placeholder" : "Bitte geben Sie den Namen des Empfängers wahrheitsgemäß ein", //
        "mobile" : "Telefonnummer", //
        "mobile_placeholder" : "persönliche Mobiltelefon aus", //
		"email" : "Email",
		"email_placeholder" : "Bitte geben Sie ihre E-Mail ein",
        "region" : "Region", //
        "region_placeholder" : "Stadt, Bezirk, Straße", //
        "address" : "Detaillierte Adresse", //
        "address_placeholder" : "Bitte geben Sie die detaillierte Adresse ein", //
        "zip" : "Postleitzahl", //
        "zip_placeholder" : "Bitte geben Sie die richtige Postleitzahl ein", //
        "name_empty" : "Bitte geben Sie den Namen des Empfängers ein", //
        "name_less" : "Maximal 2-50 Zeichen", //
        "mobile_empty" : "Bitte geben Sie die Handynummer ein", //
        "mobile_less" : "Bitte geben Sie die Handynummer im richtigen Format ein", //
        "region_empty" : "Bitte wählen Sie Ihre Region", //
        "address_empty" : "(Verwenden Sie Englisch)Bitte geben Sie die detaillierte Adresse ein", //
        "zip_empty" : "Bitte geben Sie die Postleitzahl ein", //
        "save_use" : "Speichern und verwenden", //
        "save" : "Speichern", //
        "add" : "Adresse hinzufügen", //
        "edit" : "Lieferadresse ändern", //
        "delete" : "Löschen", //
        "list_title" : "Lieferadresse", //
        "list_title_item" : "Verwalten", //
        "default" : "Standardmäßig", //
        "list_default" : "Standardmäßige Adresse", //
        "list_edit" : "Bearbeiten", //
        "list_delete" : "Löschen", //
        "manage_title" : "Lieferadresse verwalten", //
        "manage_empty" : "Sie haben die Lieferadresse noch nicht hinzugefügt", //
        "manage_add" : "Lieferadresse hinzufügen", //
        "confirm_del" : "Möchten Sie diese Lieferadresse wirklich löschen?", //
        "confirm_del_title" : "Löschung bestätigen", //
        "region_select" : "Bitte Region auswählen", //
        "region_cancel" : "Abbrechen", //
        "region_confirm" : "Bestätigen", //
    },
    auth:{
        "retrieve" : "Passwort wiederherstellen", //密码找回
        "mobile" : "Handynummer", //
        "email" : "E-Mail", //
        "go_signin" : "Einloggen", //
        "sure" : "Bestätigen", //
        "signin" : "Anmelden", //登录
        "signup" : "Registrieren", //注册
        "fast_signup" : "Registrieren", //快速注册
        "email_signup" : "Registrierung der E-Mail", //
        "agree" : "Klicken Sie auf Registrieren, um zuzustimmen", //
        "agreement" : "《Benutzervereinbarung》", //
        "signup_succ" : "Registrierung erfolgreich", //
        "signup_agreement" : "Registrierungsvereinbarung", //
    },
	auth_signin:{
		"username_placeholder" : "Benutzername/E-Mail", //用户名/邮箱/手机号
		"password_placeholder" : "Passwort eingeben", //请输入密码
		"forget" : "Passwort vergessen?", //忘记密码？
		"third_party" : "Drittanbieter-Login", //
		"wechat" : "WeChat", //微信
		"passport_empty" : "Passwort eingeben", //请输入密码
		"passport_less" : "Geben Sie ein mindestens 6-stelliges Passwort ein", //至少输入6位密码
		"expire" : "Anmeldung ist nicht mehr aktuell", //登录过期
		"username_empty" : "Bitte geben Sie Benutzername", //请输入用户名
	},
	auth_bind:{
		"mobile" : "Handy binden", //绑定手机
		"code_placeholder" : "Handy-Bestätigungscode", //
		"username_placeholder" : "Bitte geben sie ihre Handynummer ein", //请输入手机号
		"passport_placeholder" : "Passwort setzen", //设置密码
		"confirmPassword_placeholder" : "Passwort bestätigen", //确认密码
		"tips" : "6-20 stellige Zahlen/Buchstaben/Symbole", //
		"finish" : "Fertig", //完成
		"mobile_less" : "Bitte geben Sie die Handynummer im richtigen Format ein", //
		"code_empty" : "Bitte geben Sie den Bestätigungscode ein", //
		"code_less" : "Bitte geben Sie den 6-stelligen Bestätigungscode ein", //
		"password_empty" : "Bitte Passwort eingeben", //
		"password_less" : "Bitte geben Sie ein Passwort mit 6-20 Zeichen ein", //
		"confirmPassword_empty" : "Bitte geben Sie das Bestätigungspasswort ein", //
		"passport_error" : "Das Bestätigungspasswort stimmt nicht mit dem eingegebenen passwort überein", //
	},
	auth_email:{
		"confirm_tips" : "Link zur Passwortänderung gesendet an", //密码修改链接已发送至
		"email_placeholder" : "Bitte geben Sie ihre E-Mail ein", //请输入您的邮箱
		"tips" : "Wir senden den Link zur Passwortänderung an Ihre E-Mail", //我们将发送密码修改链接到您绑定的邮箱
		"send" : "E-Mail senden", //发送邮件
		"empty" : "E-Mail eingeben", //请输入邮箱
		"validator_error" : "Falsche E-Mail-Adresse", //邮箱地址不正确
		"username_placeholder" : "Benutzername", //用户名
		"username_tips" : "Der Benutzername besteht aus 3- bis 25-stelligen Ziffern, die englische Buchstaben und Zahlen enthalten können", //
		"passport_tips" : "6-20 stellige Zahlen/Buchstaben/Symbole", //
		"signup_email_placeholder" : "E-Mail-Adresse", //邮箱地址
		"email_tips" : "E-Mail eingeben", //请输入邮箱地址
		"username_empty" : "Bitte geben Sie einen Benutzernamen mit 3-25 Zeichen ein", //
		"password_empty" : "Passwort eingeben", //请输入密码
		"password_less" : "Bitte geben Sie ein Passwort mit 6-20 Zeichen ein", //
	},
    auth_mobile:{
        "retrieve_succ" : "Ihr Passwort wurde erfolgreich durch Handyabruf geändert."
    },
    balance:{
        "usable_title" : "Verfügbare Mittel", //
        "desc" : "Verfügbare Mittel （$）", //
        "withdraw" : "Geldabhebung", //
        "withdraw_history" : "Aufzeichnung der Geldabhebung", // //
        "withdraw_show" : "Details von Mitteln anzeigen", //
        "history_title" : "Details von Mitteln", //
        "history_empty" : "Keine Details", //
        "history_all" : "Alle", //
        "history_income" : "Einnahmen", //
        "history_expend" : "Ausgaben", //
    },
    withdraw:{
        "history_title" : "Aufzeichnung der Geldabhebung", //
        "history_empty" : "Keine Aufzeichnungen", //
        "history_confirm" : "Gibt an, ob die Geldabhebung abgebrochen werden soll", //
        "history_confirm_title" : "Abbrechen bestätigen", //
        "title" : "Geldabhebung", //
        "succ_title" : "Antrag der Geldabhebung eingereicht", //
        "succ_desc" : "Bitte warten Sie, bis der/die Bühnenarbeiter/in überprüft hat", //
        "amount" : "Betrag der Geldabhebung ", //
        "remarks" : "Anmerkungen", //
        "btn_finish" : "Fertig", //
        "subtitle" : "Betrag der Geldabhebung ", //
        "tips" : "Über den Umfang der Geldabhebung  hinaus", //
        "mentioning_balances" : "Verfügbarer Restbetrag $", //
        "all" : "Abhebung des gesamten Geldes", //
        "remark_placeholder" : "Bitte geben Sie den Banknamen und die Bankkartennummer ein", //
        "btn_submit" : "Einreichen", //
        "amount_empty" : "Bitte geben Sie den Betrag der Geldabhebung ein", //
        "remark_empty" : "Bitte geben Sie den Banknamen und die Bankkartennummer ein", //
        "item_title" : "Händleranmerkungen", //
        "item_amount" : "Betrag der Geldabhebung ", //
        "item_time" : "Antragszeit", //
        "item_remark" : "Mitgliedsnotizen", //
        "item_cancel" : "Geldabhebung abbrechen", //
        "wait" : "Zu behandelnd", //
        "finish" : "Erfolgreiche Geldabhebung", //
        "cancel" : "Abgebrochen", //
        "failed" : "Geldabhebung fehlgeschlagen", //
    },
    bonus:{
       "list_title" : "Meine Empfehlung", //
       "recommended" : "Empfohlen", //
       "amount" : "Schon verteilt", //
       "rule" : "Regeln der Provisionsverteilung", //
       "balance" : "Verfügbare Mittel", //
       "recommend" : "Die von mir empfohlenen Mitglieder", //
       "order_empty" : "Keine empfohlene Bestellung", //
       "recommend_rank" : "Klasse", //
       "recommend_amount" : "Menschanzahl", //
       "recommend_score" : "Verteilen von Punkten", //
       "recommend_price" : "Gewinnanteil aus Bargeld", //
       "recommend_empty" : "Keine Empfehlung", //
       "order_sn" : "Bestellnummer", //
       "cash" : "Bargeld", //
       "wait" : "Wird überprüft", //
       "finish" : "Schon verteilt", //
       "cancel" : "Abgebrochen", //
       "revoke" : "Aufgehoben", //
       "type_signup" : "Gewinnanteil aufgrund der empfohlenen Registrierung", //
       "type_order" : "Gewinnanteil aufgrund der empfohlenen Bestellungen", //
       "score_signup" : "Ranglisten-Bonuspunkte", //
       "score_order" : "Konsumbonuspunkte", //
       "my_qrcode" : "Mein erweiterter QR-Code", //
       "qr_desc" : "QR-Code scannen und meinem Laden folgen", //
       "qr_share" : "Teilen des Ladens", //
       "qr_copy" : "Kopieren von Links", //
       "qr_share_title" : "Gewinnanteil aufgrund der Empfehlung", //
       "qr_share_desc" : "Klicken Sie auf den Link, um dem Laden zu folgen und Werber zu werden, um mehr Gewinnanteil zu bekommen", //
       "qr_link" : "Für Sie wurden Werbelinks generiert", //
       "btn_confirm" : "Bestätigen", //
    },
    cart:{
        "title" : "Warenkorb", //购物车
        "edit" : "Bearbeiten", //编辑
        "finish" : "Fertig", //完成
        "select_all" : "Alle auswählen", //全选
        "total" : "Total:", //合计
        "delete" : "Löschen", //删除
        "checkout" : "Bezahlen", //结算
        "empty" : "Ihr Warenkorb ist noch leer", //您的购物车还是空的
        "no_signup" : "Melden Sie sich an, um Artikel im Warenkorb anzuzeigen", //登录后即可查看购物车中的商品
        "gohome" : "Herumschauen", //随便逛逛
        "gosignin" : "Einloggen", //去登录
        "sold_out" : "Ausverkauft", //已售罄
        "only_left" : "Nur noch", //仅剩
        "piece" : "Stücke", //件
        "promos_tag" : "Verkaufsförderung", //促销
        "delete_empty" : "Derzeit sind keine Artikel zum Löschen vorhanden", //当前没有可删除的商品
        "no_reduce" : "Ich kann es nicht ertragen, Waren können nicht mehr reduziert werden", //
        "out_of_stock" : "Der Gesamtbestand dieses Artikels ist unzureichend", //
        "promos" : "Schon erfüllt", //
        "un_promos" : "Bedingung für Sonderangebot wird nicht erfüllt ", //
        "order_promos" : "Sonderangebot des Bestellartikels", //
    },
    cashgift:{
        "list_title" : "Mein Coupon", //Coupon
        "list_empty" : "Noch kein Fügen Sie einen glücklichen roten Umschlag hinzu", //
        "unuse" : "Nicht benutzt", //
        "used" : "Schon benutzt", //
        "expired" : "Abgelaufen", //
        "bonus_sn_placeholder" : "Bitte geben Sie die Seriennummer des Coupon ein", //
        "bonus_add" : "Fügen Coupon", //
        "bonus_sn_empty" : "Bitte geben Sie die 10-stellige Seriennummer ein", //
        "bonus_add_succ" : "Coupon wurde erfolgreich hinzugefügt", //
        "no_use_bonus" : "Keinen Coupon verwenden", //
        "full" : "Voll", //
        "can_use" : "kann es verwendet werden", //
    },
    coupon: {
		"list_title" : "我的优惠券",
		"list_empty" : "暂无优惠券",
		"full" : "满",
		"can_use" : "元可使用",
		"unuse" : "未使用",
		"used" : "已使用",
		"expired" : "已过期",
		"redbag_title" : "我的红包",
		"can_use_coupon" : "可使用优惠券",
		"no_use_coupon" : "不使用优惠券",
		"redbag_empty" : "暂无红包",
		"piece" : "张",
	},
    category:{
        "title" : "Einstufung", //分类
        "all" : "Alle", //全部
        "enter": 'eingeben',
		"column": 'Spalte'
    },
    checkout:{
        "title" : "Bestellung bestätigen", //
        "title_shipping" : "Versandart", //
        "title_invoice" : "Rechnungsart", //
        "title_cashgif" : "Verwenden Sie Coupon", //
        "title_product_price" : "Betrag des Artikels", //
        "title_tax_price" : "Steuerbetrag der Rechnung", //
        "title_shipping_price" : "Frachtkosten", //
        "total_price" : "Tatsächliche Zahlung", //
        // "total_price_tips" : "( Preis ohne Steuer )", //
        "btn_checkout" : "Bestellung aufgeben", //
        "shipping_empty" : "Bitte wählen Sie die Versandart aus", //
        "consignee_empty" : "Bitte geben Sie die Lieferadresse ein", //
        "cashgift_unuse" : "Nicht benutzt", //
        "cashgift_nouse" : "Nicht verfügbar", //
        "cashgift_tips" : "1 Stücke ausgewählt", //
        "cashgift_canuse" : "Stücke verfügbar", //
        "no_invoice" : "Keine Rechnung erforderlich", //
        "invoice_type_empty" : "Bitte wählen Sie die Rechnungsart aus", //
        "no_shipping_price" : "kostenlos für Frachtkosten", //
        "goback_mess" : "Gute Waren verkaufen sich gut</br>bitte sorgfältig überlegen.", //
        "goback_cancel_text" : "leave", //去意已决
        "goback_confirm_text" : "Abbrechen", //再想想
        "invoice_header" : "Rechnungsinformationen eingeben", //
        "invoice_type_title" : "Rechnungsart", //
        "invoice_tips" : "Sie haben Angst, Papierrechnungen zu verlieren? Probieren Sie die elektronische Rechnung aus!", //
        "invoice_title" : "Rechnungsempfänger", //
        "invoice_personal" : "Einzelperson", //
        "invoice_content" : "Rechnungsdetails", //
        "invoice_btn_submit" : "Bestätigen", //
        "invoice_empty" : "Bitte geben Sie die vollständigen Rechnungsinformationen ein", //
        "shipping_price" : "Versandkosten", //
        "goods_list_header" : "Liste der Waren", //
        "total" : "Insgesamt: ", //
        "piece" : " Stücke", //
        "score_header" : "Abzug mit Bonuspunkten", //
        "score_most" : "Maximal verfügbar ", //
        "score" : " Bonuspunkte", //
        "deduct_from" : "Abzug pro Bonuspunkt $", //
        "rmb" : " Dollar", //
        "no_score" : "Keine Bonuspunkte verfügbar", //
        "score_placeholder" : "Geben Sie hier die Bonuspunkte ein", //
        "delivery_time" : "Anlieferungszeit", //
        "comment_title" : "Nachricht des Käufers", //
        "comment_placeholder" : "Optional: Beschreibung dieser Transaktion (es wird empfohlen, den mit dem Verkäufer vereinbarten Inhalt auszufüllen), Wer Maßgeschneiderte Produkte Benötigt, Hinterlässt Hier Auch Eine Nachricht.", //
        "address_empty" : "Sie haben noch keine Adresse. Klicken Sie hier, um sie hinzuzufügen.", //
        "promos_preferential" : "Rabattbetrag", //
        "promos_cashgift" : "Coupon", //
        "promos_score" : "Bonuspunkte", //
        "promos_order_reduction" : "Sonderangebot des Bestellartikels", //
        "promos_goods_reduction" : "Sonderangebot der Waren", //
        "promos_coupon_reduction" : "Coupon", //
        "promos_combined_promos" : "Gruppenkauf", //
        "promos_transport_title" : "Frachtkosten", //
        'tax_header': 'Steuernummer', // 税号
        'tax_tips': 'Bequem für die Zollabfertigung', // 税号为什么要填写
        'import_duty': 'Steuergebühr', // 进口关税
        'price_tips': '「 Preis ohne Steuer 」', //不含税价格!

        "coo": 'Erforderliche Ursprungsbescheinigung(COO)', //需要原产地证书
        "coo_fee": 'COO Gebühren', //产地证书费用
        "yes": 'Ja', //是
        "no": 'Nein' //否
    },
    payment:{
        "header" : "Kassierer", //
        "order_succ" : "Bestellung erfolgreich aufgegeben, bitte Zahlungsweise auswählen", //
        "total_price" : "Total", //
        "teegon_wechat" : "Zahlung per WeChat von Tiangong Kassierer", //
        "btn_pay" : "Sofortige Bezahlung", //
        "goback_mess" : "Die Ware ist im Handumdrehen verschwunden. </br> Möchten Sie die Zahlung wirklich aufgeben?", //
        "goback_cancel_text" : "leave", //
        "goback_confirm_text" : "Abbrechen", //
        "code_empty" : "Bitte wählen Sie eine Zahlungsweise aus", //
        "succed_header" : "Erfolgreich gekauft", //
        "order_succed" : "Bestellung erfolgreich aufgegeben", //
        "exchange_order_succed" : "Herzlichen Glückwunsch zu Ihrem erfolgreichen Austausch", //
        "order_detail" : "Bestelldetails", //
    },
    discount:{
        "header" : "Sonderangebot", //
        "empty" : "Kein Sonderangebot", //
        "range_0" : "Gilt für alle Waren", //
        "range_1" : "Gilt für einige klassifizierte Waren", //
        "range_2" : "Gilt für einige Marken", //
        "range_3" : "Gilt für einige Waren", //
        "range_canuse" : "Anwendbar", //
        "is_end" : "Aktivität schon beendet", //
        "waiting" : "Bitte bleiben Sie dran",
        "is_waiting" : "Sonderangebot noch nicht gestartet", //
        "list_empty" : "Derzeit keine Ware", //
        "no_more" : "Keine weiteren Waren",
        "review_rate" : "Gute Bewertung", //
        "sales_count" : "Absatzvolumen", //
        "surplus" : "Überig", //
        "day" : "Tage", //
        "hour" : "Stunden", //
        "minute" : "Minuten", //
        "second" : "Sekunden", //
    },
    promotions:{
        "no_more" : "Keine weiteren Waren",
        "endtime" : "Verbleibende Zeit bis zum Ende des Sonderangebots",
        "day" : "Tage",
        "hour" : "Stunden",
        "minute" : "Minuten",
        "second" : "Sekunden",
    },
    home:{
        "goodproduct" : "Beliebte Empfehlung", //热门推荐
        "hotproduct" : "Verkaufsrang", //销量排行
        "recentproduct" : "Neue Ankunft", //新品上架
		"suitproducts": "Kombinierte Ware", //组合商品
		"header_placeholder" : "Wonach suchen Sie?", //想找什么？
        "menu_activity" : "Sonderangebot", //优惠活动
        "menu_integralmall" : "Austausch von Bonuspunkte", //积分商城
        "menu_order" : "Bestellung", //订单
        "menu_bonus" : "Coupon", //红包
        "menu1": "Multirotor",
		"menu2": "Starrflügel",
		"menu3": "FPV",
		"menu4": "Roboter",
		"menu5": "T-DRONES",
        "product_buy" : "Schon gekauft", // 人已购买
        "share_title" : "Gewinnanteil aufgrund der Empfehlung", //
        "share_desc" : "Klicken Sie auf den Link, um dem Laden zu folgen und Werber zu werden, um mehr Gewinnanteil zu bekommen", //
    },
    integralmall:{
        "header" : "Einkaufszentrum mit angesammelten Bonuspunkten", //
        "hotproduct" : "Bestseller", //
        "allproduct" : "Alle Waren", //
        "no_more" : "Es gibt keine weiteren Waren ", //
        "score" : "Bonuspunkte", //
    },
    message:{
        "header" : "Nachrichtenzentrum", //
        "order" : "Bestellnachricht", //
        "notice" : "Benachrichtigungsnachricht", //
        "empty" : "Überhaupt keine Nachrichten", //
        "no_message" : "Sie haben noch keine Nachricht erhalten", //
    },
    order:{
        "header" : "Meine Bestellung", //
        "empty" : "Ihre Bestellung ist leer", //
        "gohome" : "Herumschauen", //
        "copy" : "Kopieren", //
        "all" : "Alle", //
        "created" : "Noch nicht bezahlt", //
        "paid" : "Noch nicht versendet", //
        "status_cancelled" : "Abgebrochen", //
        "back_info": "Überweisungsinformationen", //转账信息
        "status_finished" : "Abgeschlossen", //
        "status_deliveried" : "Noch nicht bewertet", //
        "status_delivering" : "Im Versand", //
        "nav_delivering" : "Waren noch nicht erhalten", //
        "nav_deliveried" : "Noch nicht bewertet", //
        "comment_3" : "Gute Bewertung", //
        "comment_2" : "Mittlere Bewertung", //
        "comment_1" : "Schlechte Bewertung", //
        "sn" : "Bestellnummer", //
        "total" : "Gesamt", //
        "total_price" : "Total", //
        "product" : "Stücke Artikel", //
        "shipping_price" : "Inklusive Frachtkosten", //
        "btn_cancel" : "Bestellung stornieren", //
        "cancels" : "Abbrechen", //
        "cancels_finish" : "Fertig", //
        "go_payment" : "Bezahlen", //
        "btn_track" : "Logistik anzeigen", //
        "btn_confirm" : "Empfang bestätigen", //
        "btn_comment" : "Bewertung teilen", //
        "no_want" : "Ich will es nicht mehr kaufen", //
        "no_payment" : "Zahlung fehlgeschlagen", //
        "no_price" : "Der Preis ist teuer.", //
        "no_store" : "Nicht vorrätig", //
        "long_wait" : "Wartezeit ist zu lang", //
        "confirm_title" : "Empfang bestätigen", //
        "confirm_content" : "Empfang bestätigen?", //
        "cancel_reason_empty" : "Bitte wählen Sie den Grund für das Abbrechen", //
        "detail_header" : "Bestelldetails", //
        "detail_status_0" : "Warten auf Zahlung", //
        "detail_status_1" : "Noch nicht versendet", //
        "detail_status_2" : "Im Versand", //
        "detail_status_3" : "Noch nicht bewertet", //
        "detail_status_4" : "Abgeschlossen", //
        "detail_status_5" : "Abgebrochen", //
        "detail_status_6" : "Waren vorbereiten", //
        "detail_score" : "Bonuspunkte", //
        "detail_more" : "Nur noch", //
        "piece" : "Stücke", //
        "add_time" : "Bestellzeitpunkt", //
        "is_exchange_good_pay" : "Zahlungsweise:Bonusunkteaustausch", //
        "payment" : "Zahlungsweise", //
        "shipping" : "Versandart", //
        "product_price" : "Gesamtbetrag der Waren", //
        "tax_price" : "Steuerbetrag der Rechnung", //
        "detail_shipping_price" : "Frachtkosten", //
        "detail_total_price" : "Tatsächliche Zahlung", //
        "copy_succed" : "Erfolgreich kopiert", //
        "no_shipping_price" : "kostenlos für Frachtkosten", //
        "track_header" : "Auftragsverfolgung", //
        "track_vendor_name" : "Transportquelle", //
        "trade_header" : "Erfolgreiche Transaktion", //
        "trade_succed" : "Erfolgreiche Transaktion, der Verkäufer erhält Ihre Zahlung!", //
        "go_comment" : "Sofortige Bewertung", //
        "go_detail" : "Bestelldetails", //
        "check_detail" : "Bestellung anzeigen", //
        "comment_header" : "Artikel bewerten", //
        "comment_submit" : "Einreichen", //
        "comment_content" : "Bitte geben Sie hier Ihre Bewertung ein", //
        "comment_content_empty" : "Bitte bewerten Sie den Artikel", //
        "comment_succed" : "Erfolgreich bewertet", //
        "comment_succed_tips" : "Produktbewertung erfolgreich, Vielen Dank für Ihre Bewertung.", //
        "comment_gohome" : "Geh wieder einkaufen", //
    },
    product:{
        "sort_default" : "Umfassendes Ranking", //
        "sort_price_asc" : "Preis von niedrig zu hoch", //
        "sort_price_desc" : "Preis von hoch zu niedrig", //
        "sort_credit_desc" : "Rate der guten Bewertung", //
        "sort_sale_desc" : "Verkaufsvolumen", //
        "sort_date_desc" : "Neue", //
        "product_tab" : "Artikel", //商品
        "detail_tab" : "Details", //详情
        "evaluate_tab" : "Bewerten", //
		"parameter_tab": 'Spezifikation', //规格参数
        "recom_tab" : "Empfohlene Konfiguration",
        "packing_tab" : "Liste der Pakete",
        "keyword_placeholder" : "Bitte geben Sie die Artikel ein, nach denen Sie suchen möchten", //
        "keyword_empty" : "Bitte geben Sie die Suchbegriffe ein, nach denen Sie suchen möchten", //
        "sold_out" : "Ausverkauft", //
        "only_left" : "Nur noch", //
        "piece" : "Stücke", //件
        "self_support" : "Eigenes Geschäft betreiben", //
        "review_rate" : "Gute Bewertung", //
        "sales_count" : "Absatzvolumen", //
        "add_cart_succ" : "Erfolgreich hinzugefügt", //
        "empty" : "Derzeit keine Ware", //
        "no_more" : "Keine weiteren Waren ",
    },
    product_detail:{
        "total" : "Alle", //
        "good" : "Gute Bewertung", //
        "medium" : "Mittlere Bewertung", //
        "bad" : "Schlechte Bewertung", //
        "review" : "Bewerten", //评价
        "add_cart" : "In den Warenkorb", //加入购物车
        "fastbuy" : "Jetzt kaufen", //立即购买
        "exchange" : "Jetzt einlösen", //立即兑换
        "not_stock" : "Die ausgewählten Produkte sind vorübergehend nicht verfügbar. Entschuldigung!", //所选产品暂时无货，非常抱歉！
        "not_enough_score" : "Bonuspunkte unzureichend", //积分不足
        "sure" : "Bestätigen", //确定
        "properties_empty" : "Bitte wählen Sie Produkteigenschaften", //
        "not_enough_stock" : "Unzureichender Warenbestand", //
        "exchange_title" : "Einlösen bestätigen", //
        "exchange_message_1" : "Ob zu verwenden", //
        "exchange_message_2" : "Einlösen der Bonuspunkte", //
        "cancel_btn" : "Abbrechen", //取消
        "confirm_btn" : "Bestätigen", //确认
        "wechat_config_title" : "Warendetails", //商品详情
        "score" : "Bonuspunkte", //积分
        "在庫" : "Lagerstand", //库存
        "数量" : "Anzahl", //数量
        "max_number" : "Die Ware hat das maximale Mengenlimit für jede Bestellung erreicht", //
        "no_reduce" : "Ich kann es nicht ertragen, Waren können nicht mehr reduziert werden", //
        "no_desc" : "Keine Details zu diesem Artikel", //本商品暂无详情
        "infobuy_number_select" : "Bitte wählen Sie zu kaufen", //请选择购买
        "infobuy_number" : "Mengenklassifizierung", //数量分类
        "infobuy_selectd" : "Ausgewählt", //已选
        "infobuy_number_selectd" : "Gewählte Menge", //已选数量
        "concat" : "um den Kundendienst zu kontaktieren", //联系客服
        "current_day" : "Dieser Tag", //当天
        "next_day" : "Der nächste Tag", //次日
        "month" : "Monat", //月
        "day" : "Tag", //日
        "like" : "Gib den Daumen hoch", //点赞
        "promos_time_title" : "Verbleibende Zeit bis zum Ende des Sonderangebots", //距离活动结束时间
        "day_1" : "Tage", //天
        "hour" : "Stunden", //时
        "minute" : "Minuten", //分
        "second" : "Sekunden", //秒
        "promos_info_title" : "Informationen zur Verkaufsförderung", //促销信息
        "info_header" : "Warendetails", //商品详情
        "review_content_empty" : "Keine Bewertungsinformationen", //无评价信息
        "review_empty" : "Es gibt keine Bewertung für diesen Artikel", //本商品暂无评价
        "recommend_show_all" : "Alle anzeigen", //查看全部
        "suit_goods_selected_empty" : "Bitte wählen Sie alle Attribute des ausgewählten Artikels aus!",
        "parameter" : "Parameter",
    },
    profile:{
        "score" : "Bonuspunkte", //积分
        "record_list" : "Datensatz der Bonuspunkte", //积分记录
        "order_header" : "Meine Bestellung", //我的订单
        "order_all" : "Alle Bestellungen anzeigen", //查看全部订单
        "order_status_0" : "Noch nicht bezahlt", //待付款
        "order_status_1" : "Noch nicht versendet", //待发货
        "order_status_2" : "Waren noch nicht erhalten", //待收货
        "order_status_3" : "Fertig", //完成
        "favourite_header" : "Meine Favoriten", //我的收藏
        "address_header" : "Lieferadresse verwalten", //管理收货地址
        "cashgift_header" : "Mein Coupon", //我的红包
        "addcashgift_header" : "Coupon Hinzufügen", //添加红包
        "bonus_header" : "Meine Empfehlung", //我的推荐
        "balance_header" : "Mein Geld", //我的资金
        "help_header" : "Benutzungshilfe", //使用帮助
        "bonus_qr_header" : "Mein erweiterter QR-Code", //我的推广二维码
        "nickname_title" : "Registrieren/Anmelden", //登录/注册
        "setting_header" : "Einstellen", //设置
        "about" : "Über uns", //关于我们
        "contact" : "Kontaktieren Sie uns",
        "Payment" : "Zahlungsanleitung",
        "help" : "Bestellhilfe",
        "Postsale" : "Beschreibung des Kundendienstes",
        "warranty" : "Garantiebestimmungen",
        "signout" : "Abmelden", //退出登录
        "signout_confirm" : "Abmelden bestätigen", //确认退出
        "info_header" : "Persönliche Daten", //个人资料
        "edit_nickname" : "Spitzname ändern", //修改昵称
        "gender" : "Geschlecht", //性别
        "edit_pwd" : "Passwort ändern", //修改密码
        "male" : "männlich", //男
        "female" : "weiblich", //女
        "secret" : "Geheimhaltung", //保密
        "nickname_placeholder" : "Geben Sie einen Spitznamen ein", //请输入昵称
        "nickname_empty" : "Bitte geben Sie 1-25 Wörter als Ihren Spitznamen ein", //
        "nickname_succ" : "Spitzname erfolgreich geändert", //修改昵称成功
        "oldpass_empty" : "Das aktuelle Passwort darf nicht leer sein", //
        "pass_less" : "Bitte geben Sie ein Passwort mit 6-20 Zeichen ein", //
        "newpass_empty" : "Neues Passwort darf nicht leer sein", //
        "confirpass_empty" : "Bitte geben Sie das Bestätigungspasswort ein", //
        "confirpass_false" : "Das Bestätigungspasswort stimmt nicht mit dem eingegebenen passwort überein", //
        "btn_save" : "Speichern", //保存
        "add_header" : "Informationen vervollständigen", //
        "skip" : "Überspringen", //跳过
        "add_tips" : "Die mit [*] sind erforderlich", //
        "add_submit" : "Fertig", //
        "placeholder" : "Bitte eingeben", //
        "add_succ" : "Informationsvervollständigung erfolgreich", //
        "product_empty" : "Es gibt vorübergehend keine Ware", //
        "gohome" : "Herumschauen", //
        "not_stock" : "Nicht mehr am Lager", //
        "only_left" : "Nur noch", //
        "piece" : "Stücke", //
        "delete" : "Löschen", //
        "confirm_del_title" : "Löschung bestätigen", //
        "confirm_del_mess" : "Möchten Sie diesen Artikel löschen?", //
        "share" : "Teilen", //
        "share_refresh" : "Aktualisieren", //
        "share_to" : "Teilen mit", //
        "share_wechat" : "WeChat", //
        "share_blog" : "微博", //
        "share_qq" : "QQ", //
        "share_cancel" : "Abbrechen", //
        "change_avatar" : "Ändern Sie das Benutzerbild", //
        "change_avatar_placeholder" : "Bitte wählen Sie ein Benutzerbild aus", //
        "upload" : "Wird hochgeladen...", //
        "image_type" : "Bildtyp muss eines der Bildformate wie .gif,jpeg,jpg,png,bmp sein.", //
    },
    recommend:{
        "product" : "Verwandte Waren",
        "accessory" : "Relevante zusammenpassende Waren",
        "no_more" : "Keine weiteren Waren", //没有更多了
    },
    score:{
        "header" : "Meine Bonuspunkte",
        "can_use" : "Derzeit verfügbare Bonuspunkte",
        "all" : "Alle",
        "income" : "Einnahmen",
        "expend" : "Ausgaben",
        "empty" : "Kein Datensatz der Bonuspunkte",
        "exchange_succ" : "Bonuspunkte erfolgreich eingelöst",
        "rule_header" : "Regel der Bonuspunkte",
        "have_score" : "Bonuspunkte erhalten",
        "expend_score" : "Bonuspunkte zahlen",
        "item_score" : "Bonuspunkte",
        "platform" : "Anwendbare Plattform",
        "to_exchange" : "Jetzt einlösen",
        "confirm_use" : "Verwendung bestimmen",
        "exchange_score" : "Bonuspunkte, einlösen",
        "coupon" : "Coupon?",
        "confirm_btn" : "Bestätigen",
		"tip_message" : 'Die zu erhaltenen Bonuspunkte werden nach erfolgreicher Zahlung automatisch zu den gesamten Bonuspunkten hinzugefügt!',
		"tip_btn_text" : "Ich verstehe",
    },
    search:{
        "header" : "Letzte Suche",
        "hot_header" : "Beliebte Suchanfragen",
        "placeholder" : "Bitte geben Sie die Artikel ein, nach denen Sie suchen möchten",
        "cancel" : "Abbrechen",
        "keyword_empty" : "Bitte geben Sie die Suchbegriffe ein, nach denen Sie suchen möchten",
    },
}



// WEBPACK FOOTER //
// ./src/assets/i18n/de_de.js